import React from "react";
import PropTypes from "prop-types";
import { ButtonProps as MuiButtonProps } from "@mui/material";
import { Button } from "@wealthx/ui";
import { CircularProgress, CIRCULAR_PROGRESS_SX, getStandardButtonSx } from "./style";

interface StandardButtonProps {
  children: React.ReactNode;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  hidden?: boolean;
  disabled?: boolean;
  variant?: MuiButtonProps["variant"];
  classes?: object | string; // For MuiButton classes override
  type?: "button" | "submit" | "reset";
  customColor?: "danger" | "neutralPrimary" | "neutralSecondary";
  loading?: boolean;
  dense?: boolean;
}

const StandardButton: React.FC<StandardButtonProps> = ({
  children,
  endIcon,
  startIcon,
  onClick,
  hidden,
  disabled = false,
  variant = "outlined",
  classes: customClasses,
  type = "button",
  customColor,
  loading,
  dense = false,
}) => {
  return (
    <Button
      variant={variant}
      endIcon={endIcon}
      startIcon={startIcon}
      disabled={disabled || loading}
      type={type}
      customColor={customColor}
      dense={dense}
      hidden={hidden}
      onClick={onClick}
      className={typeof customClasses === "string" ? customClasses : undefined}
      sx={[
        getStandardButtonSx({ variant, customColor, dense, hidden }),
        typeof customClasses === "object" ? customClasses : {},
      ]}
    >
      {loading && <CircularProgress size={14} sx={CIRCULAR_PROGRESS_SX} />}
      {children}
    </Button>
  );
};

StandardButton.propTypes = {
  children: PropTypes.any.isRequired,
  endIcon: PropTypes.element,
  startIcon: PropTypes.element,
  onClick: PropTypes.func,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(["text", "outlined", "contained"]),
  classes: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  customColor: PropTypes.oneOf(["danger", "neutralPrimary", "neutralSecondary"]),
  loading: PropTypes.bool,
  dense: PropTypes.bool,
};

export default StandardButton;
